import React from 'react'
import styles from "./Announcement.module.css"

const Announcement = () => {
  return (
    <div className={styles.Container}>
         Ưu đãi siêu khủng! Giao hàng miễn phí cho các đơn đặt hàng trên 100$
    </div>
  )
}

export default Announcement
